import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type AddonCreateCommand as SchemaAddonCreateCommand } from '../schemas/AddonCreateCommand';
import { type AddonDetails as SchemaAddonDetails } from '../schemas/AddonDetails';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Addons
 * @summary Create a new addon
 */
export const CreateAddonContentType = 'application/json' as const;
export type CreateAddonRequest = SchemaAddonCreateCommand;
export type CreateAddonResponses = LinkCommonErrorResponses & {
    /**
     * @description Addon created successfully
     */
    '200': {
        'application/json': SchemaAddonDetails;
    };
};
export type CreateAddonResponseSuccess = CreateAddonResponses['200']['application/json'];
export type CreateAddonSearchParams = undefined;
export type CreateAddonPathParameters = undefined;
export const CreateAddonUrl = '/addons' as const;
export const CreateAddonMethod = 'POST' as const;
export const getCreateAddonUrl = (_params?: CreateAddonPathParameters) => CreateAddonUrl;
